require './prototypes/array.coffee'



// WEBPACK FOOTER //
// ./src/prototypes.coffee